/** STATE break-level grouping (legacy STATE-OF / StateOption). */
export type ReportOptionStateOf = 'Jurisdiction' | 'Loss' | 'Pay/Prem';

/**
 * Maps persisted STATE-OF to dropdown values.
 * Legacy StandardReport.LoadSelectedOptions uppercases DB values before switch.
 */
export function mapReportOptionStateOfFromStorage(
  raw: string | null | undefined,
): ReportOptionStateOf {
  const v = (raw ?? '').trim();
  if (!v) {
    return 'Jurisdiction';
  }

  switch (v.toUpperCase()) {
    case 'JURISDICTION':
    case 'J':
      return 'Jurisdiction';
    case 'LOSS':
    case 'L':
      return 'Loss';
    case 'PAY/PREM':
    case 'PAY/PERM':
    case 'PAYPREM':
    case 'P':
      return 'Pay/Prem';
    default:
      break;
  }

  // Legacy binding XML used enum ToString (e.g. PayPrem).
  if (v === 'Jurisdiction' || v === 'Loss' || v === 'Pay/Prem') {
    return v;
  }
  if (v === 'PayPrem') {
    return 'Pay/Prem';
  }

  return 'Jurisdiction';
}

/** Match saved claim id to metadata option casing when possible. */
export function resolveClaimIdFromStorage(
  raw: string | null | undefined,
  claimIdOptions: string[],
): string {
  const id = (raw ?? '').trim();
  if (!id) {
    return '';
  }
  const match = claimIdOptions.find((x) => x.toUpperCase() === id.toUpperCase());
  return match ?? id;
}
